import CreateChoiceBoardView from "@features/tools/view/choice-boards-view/create-choice-boards-view";

const CreateChoiceBoards = () => {
  return <CreateChoiceBoardView />;
};

export default CreateChoiceBoards;
